import React, { useState, useEffect } from "react";
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from "@material-ui/core/Checkbox";
import { Typography } from "@material-ui/core";
import axios from "../../../../security/axios";
import { useAcceptJs } from "react-acceptjs";
import "../../OrderManager.css";
import NotificationBar from "../../../../components/notification-bar/NotificationBar";
import { parsePhoneNumber, getCountryCallingCode } from 'react-phone-number-input' 



const EditOrder = ({selectedOrder, onSubmitCallback, onBack, customerEmail, editBody, editType}) => {

    const authData = {
        apiLoginID: '2F5TnH8eRq',
        clientKey: '8Y7r9c7VRVzxEQHR54D4c5yRe9Sn5L5TVc2tj9jpTMNr6yVV8vgYgDLw7U5Dr3G6',
    };
    const environment = "PRODUCTION";
    const { dispatchData, loading, error } = useAcceptJs({ environment, authData });

    const [paymentAmount, setPaymentAmount] = useState(selectedOrder.sales_price);
    const [nameOnCard, setNameOnCard] = useState("");
    const [creditCardNumber, setNumber] = useState("");
    const [creditCardDate, setDate] = useState("");
    const [creditCardCSV, setCSV] = useState("");
    const [ipData, setIpData] = useState("");

    useEffect(() => {
        (async () => {
            return await fetch('https://ipapi.co/json/', { method: 'GET' } )
              .then(response => {
                if(response.ok){
                  return response.json();
                } else {
                  return {};
                }
              })
            })().then(res => {
                console.log(res);
              setIpData(res);
            });
    
      }, []);

    const [orderModifyType, setModifyType] = useState(null);

    const orderModifyTypeChange = (e, type) => {
        e.preventDefault();
        setModifyType(type);
        editType(type);
    }

    console.log(selectedOrder);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const dte = creditCardDate.split("-");
        const year = dte[0];
        const month = dte[1];

        const response = await dispatchData({
            cardData: {
                cardNumber: creditCardNumber,
                month: month,
                year: year,
                cardCode: creditCardCSV
            }
        });
        console.log(response);
        var body;
        if (orderModifyType == "editPayment") {
            body = {
                invoice_id: selectedOrder.processor_invoice_id,
                data_value: response.opaqueData.dataValue,
                cc_number: creditCardNumber.substr(-4),
                cc_year: year,
                cc_month: parseInt(month)
            }
        } else if (orderModifyType == "manualPayment") {

            body = {
                order_id: selectedOrder.id,
                ref_purchase: selectedOrder.processor_invoice_id,
                first_name: selectedOrder.buyer_first_name,
                last_name: selectedOrder.buyer_last_name,
                email: selectedOrder.email_address,
                phone_number: parsePhoneNumber(selectedOrder.buyer_phone_number).nationalNumber,
                country_code: parsePhoneNumber(selectedOrder.buyer_phone_number).countryCallingCode,
                product_id: selectedOrder.product_id,
                price: paymentAmount,
                cc_name: nameOnCard,
                cc_number: creditCardNumber.substr(-4),
                cc_date: creditCardDate,
                cc_csv: creditCardCSV,
                data_value: response.opaqueData.dataValue,
                cc_month: month,
                cc_year: year,
                ip_data: ipData
            };
            /*
            if (selectedOrder.subscription == true) {
                body.subscription = 1;
                body.subscription_frequency = selectedOrder.subscriptionFrequency;
                body.frequency_type = selectedOrder.subscriptionFrequencyPeriod;
                if (selectedOrder.perpetualSubscription == true) {
                    body.subscription_cycles = null;
                } else {
                    body.subscription_cycles = selectedOrder.cycleNumber;
                }
            } else {
                body.split_pay = 1;
                body.installments = selectedOrder.installments;
                body.installment_price = selectedOrder.installmentPrice;
            }
*/
        }

        console.log("This is it!");
        /*
        const body = {
            ref_purchase: selectedOrder.processor_invoice_id,
            first_name: selectedOrder.firstName,
            last_name: selectedOrder.lastName,
            email: selectedOrder.emailAddress,
            phone_number: selectedOrder.phoneNumber,
            product_id: selectedOrder.productId,
            price: selectedOrder.salesPrice,
            split_pay: selectedOrder.splitPay,
            subscription: selectedOrder.subscription,
            installments: selectedOrder.installments,
            installment_price: selectedOrder.installmentPrice,
            subscription_frequency: selectedOrder.subscriptionFrequency,
            frequency_type: selectedOrder.subscriptionFrequencyPeriod,
            perpetual_subscription: selectedOrder.perpetualSubscription,
            subscription_cycles: selectedOrder.cycleNumber,
            cc_name: nameOnCard,
            cc_number: creditCardNumber.substr(-4),
            cc_date: creditCardDate,
            cc_csv: creditCardCSV,
            data_value: response.opaqueData.dataValue,
            cc_month: month,
            cc_year: year
        };
        */
        console.log(body);

        if (orderModifyType == "editPayment") {
            try {
                const result = await axios.post(`/modify-order`, body);
                console.log(result);
                if(result.data.response.success == 1) {
                alert("The payment method was successfully modified.");
                } else {
                    alert("Something went wrong.")
                }
            } catch (e) {
                console.log(e);
                alert(e);
            }
        } else if (orderModifyType == "manualPayment") {
            try {
                const result = await axios.post(`/create-order`, body);
                if(result.data.response.data.transaction_id) {
                    console.log(result);
                    alert("Transaction has been created with the id: " + result.data.response.data.transaction_id);
                } else {
                    console.log(result);
                    alert("Error: " + result.data.response.errors[0]);
                }
            } catch (e) {
                console.log(e);
                alert(e);
            }
        }
        

        await onSubmitCallback();
    };

    return orderModifyType == "editPayment" ? (
        <form>
            <Typography variant="h6" gutterBottom>
                Order details
            </Typography>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Invoice ID</TableCell>
                            <TableCell>Product Name</TableCell>
                            <TableCell>Order Date</TableCell>
                            {/* <TableCell>Type</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th" scope="row">{selectedOrder.processor_invoice_id}</TableCell>
                            <TableCell>{selectedOrder.product_name}</TableCell>
                            <TableCell>{selectedOrder.order_date}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Typography variant="h6" gutterBottom>
                Edit Payment
            </Typography>
            <div className="contact-section">
                <Typography variant="body1" gutterBottom>
                    Card Info:
                </Typography>
                <div className="mt-25 dspl-inlblk">
                    <Typography variant="body1" gutterBottom>
                        Name on Card:
                    </Typography>
                    <div>
                        <div className="mt-10 mb-50">
                            <input className="w-100 contact-update-input"
                                required
                                autoComplete="false"
                                type="text"
                                value={nameOnCard}
                                onChange={e => setNameOnCard(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className="mt-25 dspl-inlblk">
                    <Typography variant="body1" gutterBottom>
                        Credit Card Number:
                    </Typography>
                    <div>
                        <div className="mt-10 mb-50">
                            <input className="w-100 contact-update-input creditcardnumber"
                                required
                                autoComplete="false"
                                inputmode="numeric"
                                pattern="[\d ]{10,30}"
                                value={creditCardNumber}
                                onChange={e => setNumber(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className="mt-25 dspl-inlblk">
                    <Typography variant="body1" gutterBottom>
                        Expiration Date:
                    </Typography>
                    <div>
                        <div className="mt-10 mb-50">
                            <input className="w-100 contact-update-input"
                                required
                                autoComplete="false"
                                type="month"
                                value={creditCardDate}
                                onChange={e => setDate(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className="mt-25 dspl-inlblk">
                    <Typography variant="body1" gutterBottom>
                        CVV:
                    </Typography>
                    <div>
                        <div className="mt-10 mb-50">
                            <input className="w-100 contact-update-input"
                                required
                                autoComplete="false"
                                inputmode="numeric"
                                maxlength="4"
                                value={creditCardCSV}
                                onChange={e => setCSV(e.target.value)} />
                        </div>
                    </div>
                </div>
            </div>
            <button className="button save-btn accent mr-1"
                name="editPayment"
                onClick={handleSubmit}>
                Submit
            </button>
            <button className="button save-btn accent mr-1"
                name="back1"
                onClick={e => orderModifyTypeChange(e, null)}>
                Back
            </button>
        </form>
    ) : orderModifyType == "manualPayment" ? (
        <form>
            <Typography variant="h6" gutterBottom>
                Order details
            </Typography>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Invoice ID</TableCell>
                            <TableCell>Product Name</TableCell>
                            <TableCell>Order Date</TableCell>
                            {/* <TableCell>Type</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th" scope="row">{selectedOrder.processor_invoice_id}</TableCell>
                            <TableCell>{selectedOrder.product_name}</TableCell>
                            <TableCell>{selectedOrder.order_date}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Typography variant="h6" gutterBottom>
                Manual Payment
            </Typography>
            <div className="contact-section">
            <div className="mt-25 dspl-inlblk">
                    <Typography variant="body1" gutterBottom>
                        Payment Amount:
                    </Typography>
                    <div>
                        <div className="mt-10 mb-50">
                            <input className="w-100 contact-update-input"
                                required
                                type="text"
                                value={paymentAmount}
                                onChange={e => setPaymentAmount(e.target.value)} />
                        </div>
                    </div>
                </div>
                <Typography variant="body1" gutterBottom>
                    Card Info:
                </Typography>
                <div className="mt-25 dspl-inlblk">
                    <Typography variant="body1" gutterBottom>
                        Name on Card:
                    </Typography>
                    <div>
                        <div className="mt-10 mb-50">
                            <input className="w-100 contact-update-input"
                                required
                                type="text"
                                value={nameOnCard}
                                onChange={e => setNameOnCard(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className="mt-25 dspl-inlblk">
                    <Typography variant="body1" gutterBottom>
                        Credit Card Number:
                    </Typography>
                    <div>
                        <div className="mt-10 mb-50">
                            <input className="w-100 contact-update-input creditcardnumber"
                                required
                                inputmode="numeric"
                                pattern="[\d ]{10,30}"
                                value={creditCardNumber}
                                onChange={e => setNumber(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className="mt-25 dspl-inlblk">
                    <Typography variant="body1" gutterBottom>
                        Expiration Date:
                    </Typography>
                    <div>
                        <div className="mt-10 mb-50">
                            <input className="w-100 contact-update-input"
                                required
                                type="month"
                                value={creditCardDate}
                                onChange={e => setDate(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className="mt-25 dspl-inlblk">
                    <Typography variant="body1" gutterBottom>
                        CCV:
                    </Typography>
                    <div>
                        <div className="mt-10 mb-50">
                            <input className="w-100 contact-update-input"
                                required
                                inputmode="numeric"
                                maxlength="4"
                                value={creditCardCSV}
                                onChange={e => setCSV(e.target.value)} />
                        </div>
                    </div>
                </div>
            </div>
            <button className="button save-btn accent mr-1"
                name="editPayment"
                onClick={handleSubmit}>
                Submit
            </button>
            <button className="button save-btn accent mr-1"
                name="back2"
                onClick={e => orderModifyTypeChange(e, null)}>
                Back
            </button>

        </form>
    ) : (
        <form>
            <Typography variant="h6" gutterBottom>
                Order details
            </Typography>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Invoice ID</TableCell>
                            <TableCell>Product Name</TableCell>
                            <TableCell>Order Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th" scope="row">{selectedOrder.processor_invoice_id}</TableCell>
                            <TableCell>{selectedOrder.product_name}</TableCell>
                            <TableCell>{selectedOrder.order_date}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            {(selectedOrder.subscription == 1) || (selectedOrder.split_payment == 1) ? (
                <button className="button save-btn accent mr-1"
                    name="editPayment"
                    onClick={e => orderModifyTypeChange(e, "editPayment")}>
                    Edit Payment Details
                </button>
            ) : (
                <button className="button save-btn accent mr-1"
                    name="editPayment"
                    disabled={true}
                    title="You can only change payment details on a subscription order or a split payment order.">
                    Edit Payment Details
                </button>
            )}
            <button className="button save-btn accent mr-1"
                name="manualPayment"
                onClick={e => orderModifyTypeChange(e, "manualPayment")}>
                Manual Payment
            </button>
        </form>
    )

};


export default EditOrder;